import gql from 'graphql-tag';

export const GET_FULL_INVENTORY_LIST = gql`
  query InternalInventoryFullList($input: InternalInventoryFullList!) {
    result: internalInventoryFullList(input: $input) {
      success
      error
      list {
        id
        equipment {
          id

          price {
            wholesaleCost
            totalWholesaleCost
          }

          details {
            make
            vin
            year
            model
            name
            class
            mileage
            stockId
            condition
          }
        }
      }
    }
  }
`;
